<template>
  <component :is="display" />
</template>

<script setup>
import { useAuthStore } from '@/stores';
import { computed } from 'vue';
import HomePageWithBanner from './dynamic-pages/HomePageWithBanner.vue';
import HomePage from './HomePage.vue';

const authStore = useAuthStore();
const selectedLayout = computed(() => authStore.selectedThemeLayout);

const display = computed(() => {
  if (selectedLayout.value === 'layout_assignments_dynamic') {
    return HomePageWithBanner;
  }
  return HomePage;
})
</script>

<style scoped>

</style>
